// Inter, self-hosted: the variable font ships in the bundle instead of a
// render-blocking request to fonts.googleapis.com on every visit. Registers
// the "Inter Variable" family the theme asks for first.
import '@fontsource-variable/inter';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!, {
  // React 19 funnels render/commit errors through these root hooks, which —
  // unlike the bare Error reaching the router's errorElement — also carry the
  // React component stack (errorInfo.componentStack). Sentry.reactErrorHandler()
  // forwards that stack to Sentry, where the uploaded source maps symbolicate
  // it, so a render error like "Element type is invalid … got: object"
  // (SMARTMIXIN-WEB-38) — whose JS stack is entirely react-dom internals —
  // finally names the component that rendered the bad element.
  //
  // onCaughtError covers errors caught by an error boundary, including React
  // Router's data-router boundary; the duplicate event RouteErrorBoundary's own
  // captureException emits is dropped by Sentry's default dedupeIntegration, and
  // the kept event (emitted first, during commit) is the one with the stack.
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
